export const en = {
  accountSettings: {
    menu: {
      edit_profile: 'Edit Profile',
      cause_preferences: 'Cause Preferences',
      notification_preferences: 'Notification Preferences',
      security_settings: 'Security Settings',
      opportunity_preferences: 'Opportunity Preferences',
    },
    profileSettings: {
      profile_page_title: 'Settings › Profile',
      edit_profile: 'Edit Profile',
      full_name_hint: 'Feel free to use your preferred name of course.',
      full_name_placeholder: 'Enter your full name',
      department_label: 'Department',
      team_lead_question: 'Do you manage or lead a team at {{companyName}}?',
      location_label: 'Location',
      job_title_label: 'Job Title',
      job_title_placeholder: 'Enter your job title',
      about_placeholder: 'Say something about yourself',
      update_profile: 'Update profile',
    },
    causePreferences: {
      page_title: 'Settings › Cause Preferences',
      heading: 'Cause Preferences',
      description:
        'Which causes are you most interested in supporting through volunteering?',
      max_causes_hint:
        'To help us personalize your experience, we recommend selecting a maximum of 5 causes',
      update_button: 'Update profile',
    },
    notificationPreferences: {
      page_title: 'Settings › Notification Preferences',
      heading: 'Notification Preferences',
      newsletter: {
        label: 'Newsletter',
        opt_in: 'Opt-In',
        opt_out: 'Opt-Out',
      },
      nearby_event_updates: {
        label: 'Nearby Event Updates',
        description:
          'Get email updates about events happening near you',
        opt_in: 'Opt-In',
        opt_out: 'Opt-Out',},
      cause_updates: {
        label: 'Cause Updates',
        description: 'Get email updates related to your selected causes',
        opt_in: 'Opt-In',
        opt_out: 'Opt-Out',
      },
      teams_section_title: 'Microsoft Teams Preferences',
      teams_updates: {
        label: 'Teams Messages',
        description: 'Receive direct messages in Microsoft Teams from your company',
      },
      slack_updates: {
        label: 'Slack Notifications',
        description: 'Receive notifications via Slack about important updates',
        opt_in: 'Opt-In',
        opt_out: 'Opt-Out',
      },
      update_button: 'Update preferences',
    },
    securitySettings: {
      page_title: 'Settings › Security',
      heading: 'Change Password',
      description: 'Please enter your current password to confirm your changes',
      current_password: {
        label: 'Current Password',
        placeholder: '•••••••',
      },
      new_password: {
        label: 'New Password',
        placeholder: '•••••••',
        error_same: 'New password must be different.',
      },
      confirm_password: {
        label: 'Confirm New Password',
        placeholder: '•••••••',
        error_match: 'Passwords must match.',
      },
      update_button: 'Update password',
      success_message: 'Password updated successfully',
    },
  },
}
